import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import { UrlConstantes } from "../../utilerias/constantes/urlconstantes";
import {
  MatrizCatalogoReq,
  MatrizCatalogoRes,
} from "../../shared/model/iso42001/matriz-riesgo.model";

/**
 * Configuración de las hojas de apoyo del FOS-005.
 *
 * Guardar y eliminar devuelven los seis catálogos ya releídos de la base: la
 * pantalla se repinta con eso y nunca con lo que ella supone que quedó.
 */
@Injectable({ providedIn: "root" })
export class HojasApoyoService {
  constructor(private http: HttpClient) {}

  consultar(): Observable<MatrizCatalogoRes> {
    return this.http.post<MatrizCatalogoRes>(UrlConstantes.ISO42001_HOJAS_CONSULTAR, {});
  }

  guardar(req: MatrizCatalogoReq): Observable<MatrizCatalogoRes> {
    return this.http.post<MatrizCatalogoRes>(UrlConstantes.ISO42001_HOJAS_GUARDAR, req);
  }

  eliminar(req: MatrizCatalogoReq): Observable<MatrizCatalogoRes> {
    return this.http.post<MatrizCatalogoRes>(UrlConstantes.ISO42001_HOJAS_ELIMINAR, req);
  }
}
